@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';

@import '~@adv-mt/mt-empty-case-default/lib/index';
@import '~@adv-mt/mt-hero-basic/lib/index';
@import '~@adv-mt/mt-list-compare/lib/index';
@import '~@adv-mt/mt-list-makes/lib/index';
@import '~@adv-mt/mt-list-marketed-versions/lib/index';
@import '~@adv-mt/mt-list-model-details/lib/index';
@import '~@adv-mt/mt-list-models/lib/index';
@import '~@adv-mt/mt-list-pagination/lib/index';
@import '~@adv-mt/mt-list-tag-chips/lib/index';
@import '~@adv-mt/mt-list-tagcloud/lib/index';
@import '~@adv-mt/mt-list-versions/lib/index';
@import '~@adv-mt/mt-modal-add-vehicle/lib/index';
@import '~@adv-mt/mt-navigation-breadcrumb/lib/index';
@import '~@adv-mt/mt-panel-add-vehicles/lib/index';
@import '~@adv-mt/mt-panel-equipment/lib/index';
@import '~@adv-mt/mt-panel-stores/lib/index';
@import '~@adv-mt/mt-search-header/lib/index';
@import '~@adv-mt/mt-search-sidebar/lib/index';
@import '~@adv-mt/mt-search-sort/lib/index';
@import '~@adv-mt/mt-shared-section-wrapper/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-technical-detail-make-title/lib/index';
@import '~@adv-mt/mt-technical-details-panel-links/lib/index';
@import '~@adv-mt/mt-technical-details-panel-slider/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';

@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-molecule-checkbox-field/lib/index';

$w-technical-details-search-inner-sidebar: 226px;

.mt-TechnicalDetailsSearch {
  padding: 0;
  margin: 0;

  @include media-breakpoint-up(m) {
    padding: 0 0 $p-giant;
    margin: 0;
  }

  &-search {
    &Topbar {
      box-shadow: $bxsh-m;
      margin-bottom: $m-l;
      position: sticky;
      top: $h-topbar-user-mobile;
      z-index: $z-topbar-user;

      @include media-breakpoint-up(m) {
        margin-top: -$m-m;
      }
    }
  }

  &-titleHeader {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include media-breakpoint-up(l) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &-inner {
    display: flex;
    margin-top: $m-m;
    @include media-breakpoint-up(l) {
      justify-content: space-between;
    }

    &Sidebar {
      display: none;
      @include media-breakpoint-up(l) {
        display: block;
        margin-right: $p-l;
        width: $w-technical-details-search-inner-sidebar;
      }
    }

    &Content {
      width: 100%;
      @include media-breakpoint-up(l) {
        flex: 1;
      }
      & > *:first-child {
        overflow-x: scroll;
        margin-bottom: $p-l;
      }
    }

    &Empty {
      width: 100%;
    }
  }

  &Loading {
    height: 100vh;
  }
}
